import { makeStyles } from '@material-ui/core/styles';

export const useLoginFormStyle = makeStyles(theme => ({
    paper: {
        marginTop: ' 0px !important',
        marginBottom: theme.spacing(3),
        boxShadow: '0px 3px 25px #00000024',
        borderRadius: '9px 9px 9px 9px',
        opacity: '1',
        marginBottom: '0px !important',
        [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            paddingBottom: theme.spacing(3),
        },
        '@media  (max-width: 1025px)': {
            paddingBottom: '24px',
        },
    },

    loginForm: {
        background: '#f4f5f9 0% 0% no-repeat',
        position: 'relative',
        borderRadius: '5px',

        '& form': {
            width: '75%',
            margin: 'auto',
            '@media  (max-width: 767px)': {
                width: '100%',
            },
        },
        '& .formHolder': {

            '@media  (max-width: 767px)': {
                width: '100%',
                padding: '0',
            },
        },
        '& .fontLarge': {
            width: '30px',
            height: '30px',
            color: '#470A68',
            marginLeft: '10px',
            backgroundImage:
                'url(/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-icon-right_purple.png)',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '35px',
            '@media  (max-width: 767px)': {
                width: '24px',
                height: '24px',
                backgroundSize: '30px',
            },
        },
        '& p': {
            textAlign: 'justify',
            color: '#323435',
            fontFamily: 'gt-walsheim-regular',
            '@media  (max-width: 1025px)': {
                fontSize: '14px !important',
            },
        },

        '& .formLogoSection': {
            height: '100px',
            boxShadow: '0px 3px 25px #00000024',
            borderRadius: '4px 9px 0px 0px',
            marginBottom: '20px',
            background:
                'url(/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/login-header-image.jpg) ',
            '& img': {
                width: '128px',
                display: 'flex',
                margin: 'auto',
                paddingTop: '8PX',
                '@media  (max-width: 1025px)': {
                    width: '115px',
                },
            },
        },

        '& .loginBtn': {
            background: '#FFFFFF 0% 0% no-repeat ',
            border: '2px solid #DB12A9',
            borderRadius: '29px',
            color: '#470A68',
            fontFamily: 'eir-medium !important',
            outline: 'none',
            fontSize: '20px !important',
            textTransform: 'initial',
            padding: theme.spacing(1, 7),
            margin: 'auto',
            display: 'flex',
            '&:hover': {
                border: '2px solid #892BA0',
                background: '#892BA0 0% 0% no-repeat ',
                color: '#FFFFFF',
                '& .fontLarge': {
                    backgroundImage:
                        'url(/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-icon-right-white.png)',
                },
            },
            '@media  (max-width: 767px)': {
                fontSize: '18px !important',
                padding: theme.spacing(1, 4),
                margin: 'auto',
            },
        },
        '& .forgotLink': {
            color: '#323435',
            float: 'left',
            margin: '0px 14px 16px',
            fontFamily: 'gt-walsheim-regular !important',
            fontSize: '14px',
            textDecoration: 'underline',
        },
        '& .Icon': {
            color: '#892BA0',
        },

        '& .errorMessage': {
            width: '100%',
            fontFamily: 'gt-walsheim-regular',
            textAlign: 'left',
            marginTop: '.25rem',
            fontSize: 16,
            paddingBottom: '1%',
            color: '#e40046',
            display: 'block',
            '@media (max-width: 767px)': {
                textAlign: 'left',
                fontSize: 14,
            },
        },
    },
}));
